import VMdView from './VMdView'

export { VMdView }
export default VMdView
